<div class="trip-documents-container">
  <p-table
    #dt
    [columns]="cols"
    [value]="tripDocuments"
    [loading]="loading"
    [scrollable]="true"
    scrollHeight="600px"
    [autoLayout]="true"
    [lazy]="true"
    [paginator]="true"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    (onLazyLoad)="onLazyLoad($event)"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} documents"
  >
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of columns" [style.width.px]="col.width" />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-document>
      <tr>
        <td>{{ document.tripNo }}</td>
        <td>{{ document.startDate | date: "MM/dd/yyyy" }}</td>
        <td>{{ document.endDate | date: "MM/dd/yyyy" }}</td>
        <td>{{ document.productName || "N/A" }}</td>
        <td>
          <a
            href="javascript:void(0)"
            (click)="downloadFile(document)"
            style="color: #007bff; text-decoration: underline; cursor: pointer"
            >{{ document.fileName }}</a
          >
        </td>
        <td>{{ document.fileUploadDate | date: "MM/dd/yyyy" }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="cols.length" style="text-align: center">No trip documents found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
